import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const ISwear = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - I SWEAR</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - I SWEAR</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Intro]<br/>
                Wo kiska<br/>
                Yeah<br/>
                Anha<br/>
                Gaush<br/>
                Yeah yeah<br/>
                <br/>
                [Verse 1]<br/>
                Planning against me you'd never succeed at first<br/>
                Man fuck average rappers who diss me and never see me in person (bitch)<br/>
                I'm a God that you didn't believe in first<br/>
                And now all of y'all on my feet and you'all begging G for some mercy (haha)<br/>
                Deez nuts will leave you hanging like my peers (yeah)<br/>
                Man who would've thought that i would get so famous in a year (kiss)<br/>
                Fuck with me and I endeavour careers<br/>
                Motherfucker, fuck with me and that's the end of your career (anh)<br/>
                <br/>
                Haan mai kaafi dheet<br/>
                Mai haath me aaunga nai<br/>
                Wo chahte maangna feature<br/>
                Daam hai cheap to<br/>
                Haath failana nai<br/>
                Mai aa laga du kheech ke<br/>
                Faltu ki<br/>
                Agar baate yaha kari<br/>
                Mai na koi mamuli<br/>
                Banake scene mai<br/>
                Yaha se jaaunga bhai (bhai)<br/>
                Kheechke laga du chaar agar<br/>
                Peet peeche baate yaha pe<br/>
                Kari to fir maa ki aankh<br/>
                Man I'm bringing an avalanche<br/>
                Cheekhe sunayi diya<br/>
                Kara G ne jalake rakh<br/>
                If we're beefing<br/>
                I'm on feast like it's Eid after Ramadan (yeah)<br/>
                <br/>
                [Chorus]<br/>
                I'm a Don I'm a G I'm a God I'm a Beast get 'em all to their knees I Swear (I Swear)<br/>
                Better call the police cuz you're not gonna breathe<br/>
                Kill 'em all then I flee you know what I'm saying? (I'm saying)<br/>
                I'm a Don I'm a G I'm a God I'm a Beast get 'em all to their knees I Swear (I Swear)<br/>
                Better call the police cuz you're not gonna breathe<br/>
                Kill 'em all then I flee you know what I'm saying? (I'm saying)<br/>
                <br/>
                [Verse 2]<br/>
                Went through hell but na maani haar (maani haar)<br/>
                Gandhi's heart on that Dandi March (Dandi March)<br/>
                Ain't no way that I'mma fail<br/>
                Kara maine kitni dafa Rafa L(Rafael Nadal) na dali ghaas (dali ghaas)<br/>
                Hustle karke ni thakte<br/>
                Ye humse yu ladke kyu sar ye pakadte<br/>
                Kalke ye ladke le halke me kabze<br/>
                Kasam se no mercy har verse me dispersed rage<br/>
                Feeling godly hum area me jab gedi maare<br/>
                Yede chale kare to pull up shooting on anybody<br/>
                Y'all be sipping molly and end up all in your melancholy<br/>
                And you're prolly looking like bitches doing a kitty party<br/>
                <br/>
                Deke zubaan mai kabhi nai peeche hata mai<br/>
                Kamine beche imaan ye<br/>
                Mere muqaam pe<br/>
                Kabhi nai milega dhoondh<br/>
                Kabse mere pe kyun?<br/>
                Ye kare sawaal hai<br/>
                Baato ki nikle khaal par<br/>
                Kabhi nai mile jawaab ye<br/>
                Apne aap me<br/>
                Karunga sapne sach mai<br/>
                Bete tu mere se bach be<br/>
                Li maine kasme<br/>
                Kitne saalo se kaske<br/>
                Mehnat hai kari to ab se<br/>
                Game mere vash me<br/>
                Kabhi nai jeeta mai luck pe<br/>
                Sadne walo pe hamle<br/>
                Dunga nai fuck mai<br/>
                Dekhne walo pe kabze<br/>
                Karke baitha mai haq se<br/>
                Meri kalam se<br/>
                Nikle wakayi me aag<br/>
                Karunga khatam mai inko rakh (inko rakh, ko rakh)
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default ISwear;
